<template>
  <v-app-bar app color="background" elevate-on-scroll class="pb-2">
    <v-app-bar-nav-icon
      v-if="isLogged && $vuetify.breakpoint.smAndDown"
      id="mainDrawer"
      @click.prevent="toggleDrawer({ name: 'mainMenu' }) && scrollToTop()"
    />

    <router-link :to="{ name: 'home' }" class="d-flex router-link-active">
      <img
        src="@/assets/images/logo-dinamo-HSM.svg"
        height="38px"
        width="38px"
      >
    </router-link>
    <span class="title ml-3 mr-5">
      DINAMO&nbsp;
      <span class="font-weight-light"> HSM </span>
    </span>

    <v-tooltip v-if="isLogged && $vuetify.breakpoint.mdAndUp" bottom>
      <template #activator="{ on }">
        <v-btn icon v-on="on" @click="drawerIsMini = !drawerIsMini">
          <v-icon> menu_open </v-icon>
        </v-btn>
      </template>
      <span>{{ drawerIsMini ? $tc("expand") : $tc("collapse") }}</span>
    </v-tooltip>

    <v-row no-gutters align="center" justify="end">
      <notifications-list
        v-if="isLogged && canMonitor"
        @click="toggleDrawer({ name: 'notifications' })"
      />

      <account-menu :username="username" :subtitle="userType" />
    </v-row>
  </v-app-bar>
</template>

<script>
import NotificationsList from './NotificationsList'
import DrawerMixin from '@/mixins/drawer'
import AccountMenu from '../AccountMenu.vue'

export default {
  mixins: [DrawerMixin],
  components: {
    NotificationsList,
    AccountMenu
  },
  computed: {
    drawerIsMini: {
      get () {
        return this.$store.state.drawers.mainIsInMiniVariant
      },
      set () {
        this.$store.commit('drawers/toggleMiniVariantOnMain')
      }
    },
    username () {
      return this.$store.state.auth.username
    },
    userType () {
      const perm = this.$store.getters['auth/getPermissions']
      return perm.isOperator ? this.$tc('operator') : this.$tc('user')
    },
    canMonitor () {
      const perm = this.$store.getters['auth/getPermissions']
      return perm.canUserAccessRemoteLog
    },
    isLogged () {
      return this.$store.state.auth.isLogged
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // You can change this to 'auto' for instant scrolling
      })
    }
  }
}
</script>
